import { render, staticRenderFns } from "./InputCota.vue?vue&type=template&id=2c37add2&scoped=true&"
import script from "./InputCota.vue?vue&type=script&lang=js&"
export * from "./InputCota.vue?vue&type=script&lang=js&"
import style0 from "./InputCota.vue?vue&type=style&index=0&id=2c37add2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c37add2",
  null
  
)

export default component.exports